import { Select } from 'antd';
import './style.scss';
export default function CustomSelect(props) {
	return (
		<>
			<Select {...props} />
		</>
	);
}
